import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex cos-both-form-item" }
const _hoisted_2 = { class: "flex cos-both-form-item" }
const _hoisted_3 = { style: {"font-weight":"bold","padding-bottom":"4px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Warehouse Management Team will confirm in OA", -1)
const _hoisted_5 = { class: "flex cos-both-form-item" }
const _hoisted_6 = { class: "flex cos-both-form-item" }
const _hoisted_7 = { class: "flex cos-both-form-item" }

import { computed, onMounted, watch, ref, PropType, reactive } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'
import CustomerArea from '@/components/CustomerArea/index'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import SerialSelect from './serialSelect.vue'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { potentialAdd, potentialEdit } from '@/api/overseasSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { message } from '@dc-platform/dc-components'
import { useRoute } from 'vue-router'
import { goBack } from '@/hooks/cosRouter'
import { usePermissionStore } from '@/stores/permission'
import { ofbuContactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'
import calc from '@/utils/calc'
import { initObjectVal, paramCodesDataFilter } from '@/utils/index'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

import { useI18n } from 'vue-i18n'
import UploadFile from '@/components/UploadFile'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { queryMarketActivityList } from '@/api/marketing/marketingManage'
import CosSelect from '@/components/Antd/CosSelect/index.vue'

const __default__ = { name: 'customerCenterBaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<PotentialItem>,
    default: () => {
      return {
        business: {},
        contact: {}
      }
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  formItemView: {
    type: Boolean
  },
  type: {
    type: String,
    default: 'potential' // 潜在，contract 签约，clients 成交的基本信息
  },
  perfect: {
    type: Boolean,
    default: false
  },
  hideOk: {
    type: Boolean
  }
},
  setup(__props) {

const { t } = useI18n()
const permissionStore = usePermissionStore()
const permissionBtn = ref<any[]>(permissionStore.permission)
const route = useRoute()
const initForm = reactive<any>({
  business: {
    businessType: [],
    saleInfo: [{}],
    demandInfo: {
      warehouses: [{}]
    },
    erpInfo: [{}],
    replenish: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  contact: {},
  customerInfo: {},
  visitAddress: [{}]
})
const resetValue = ref(cloneDeep(initForm))
const loading = ref(false)
const form = ref<any>(cloneDeep(initForm))
const props = __props
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      const formVal = v
      initObjectVal(formVal, initForm)
      form.value = cloneDeep(formVal)
      resetValue.value = cloneDeep(formVal)
    }
  },
  { immediate: true }
)
const quotationAndBusinessChange = ref<boolean>(false)
// 当【价格类型】选择为【公布价】且【业务类型】选择为【仓储服务】或【头程+仓储】时
watch(
  () => [form.value.business.quotationInfo.quotationType, form.value.business.businessTypeSelect],
  (newValue, oldValue) => {
    const [quotationType, businessTypeSelect] = newValue
    quotationAndBusinessChange.value = (quotationType === 3468) &&
      (businessTypeSelect === 3438 || businessTypeSelect === 3441)
  },
  { immediate: true, deep: true }
)
watch(
  () => form.value.business.contractInfo?.paymentType,
  (newValue, oldValue) => {
    if (newValue === 3504 || newValue === 3473) {
      if (!form.value.business.contractInfo.paymentTerm) {
        form.value.business.contractInfo.paymentTerm = '10'
      }
    }
  },
  { immediate: true, deep: true }
)
const formRef = ref()
const marketRequired = ref<boolean>()
const marketOptions = ref<any[]>([])
const status = computed(() => {
  // 如果是签约客户编辑，不能选择终止合作
  if (route.path.includes('/ofbu/contract/edit')) {
    return cloneDeep(dataConfig.contractStatusEnum).map((item: any) => {
      if (item.value === 22) {
        item.disabled = true
      }
      return item
    })
  }
  if (props.type === 'potential') {
    return dataConfig.potentialStatusEnum
  } else if (props.type === 'contract') {
    return dataConfig.contractStatusEnum
  } else if (props.type === 'clients') {
    return dataConfig.clientsStatusEnum
  }
  return []
})
watch(
  () => form.value.customerInfo?.channel,
  (val) => {
    // 目前当【线索来源】选择【市场活动、市场投放、市场渠道（合作伙伴）】时，关联市场该字段必填
    // 但是线索来源是属于层级的，该三个来源下还有一层，无法全部判断，故此处就只判断非必填的状态
    // 非必填：内部推荐1812 销售开发1813
    if (val) {
      marketRequired.value = !(val === 1812 || val === 1813)
    } else {
      marketRequired.value = false
    }
  },
  { immediate: true }
)
const paramCodeData = ref<any>({
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 货物类型
  ofbu_warehouse: [], // 合作海外仓
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_service_demand: [], // 服务需求
  ofbu_demand_info: [], // 需求海外仓
  ofbu_inbound_package_type: [], // 入库包装方式
  ofbu_erp_info: [], // 目前使用ERP
  ofbu_replenish_frequency: [], // 头程补货频次
  ofbu_business_type: [], // 客户业务类型
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_head_replenish_method: [], // 头程补货方式
  ofbu_area_code: [], // 电话区号
  ofbu_customer_size: [], // 客户规模
  ofbu_currency: [], // 币种
  ofbu_shipments: [], // 发货量
  ofbu_sku_unit: [], // SKU单位
  ofbu_quotation_type: [], // 价格类型
  ofbu_service_type: [], // 尾程服务需求
  ofbu_service_body: [], // 服务主体（服务公司）
  ofbu_payment_type: [], // 付款方式
  ofbu_client_type: [], // 客户类型
  ofbu_sales_channel: [], // 销售渠道
  ofbu_services_standard: [], // 服务标准
  ofbu_billing_term: [] // 出账周期
})
const percentValidate = async (rule: Rule, value: string) => {
  const result = form.value.business.saleInfo.reduce(
    (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
    0
  )
  if (value && result !== 100) {
    return Promise.reject(new Error(t('custom.saleInfoPercentValidate')))
  } else {
    return Promise.resolve()
  }
}
const getMarketOption = () => {
  queryMarketActivityList({ subdomain: 'cos_ofbu' }).then((res) => {
    if (res.data && res.data.length) {
      marketOptions.value = res.data.map((item: any) => ({
        label: item.activityName,
        value: item.id
      }))
    }
  })
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_warehouse',
      'ofbu_sale_platform',
      'ofbu_service_demand',
      'ofbu_demand_info',
      'ofbu_inbound_package_type',
      'ofbu_erp_info',
      'ofbu_replenish_frequency',
      'ofbu_business_type',
      'ofbu_marketing_activity',
      'ofbu_head_replenish_method',
      'ofbu_area_code',
      'ofbu_customer_size',
      'ofbu_sign_in_address_label',
      'ofbu_currency',
      'ofbu_shipments',
      'ofbu_sku_unit',
      'ofbu_quotation_type',
      'ofbu_service_type',
      'ofbu_service_body',
      'ofbu_payment_type',
      'ofbu_client_type',
      'ofbu_sales_channel',
      'ofbu_services_standard',
      'ofbu_billing_term'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.disabled) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data
    }
  })
}
onMounted(() => {
  getByParamCodes()
  getMarketOption()
})
// 海外仓月销售额
const amount = computed(() => {
  const result = form.value.business.demandInfo.warehouses.reduce(
    (prev: number, curr: any) => calc.Add(prev, Number(curr.amount) || 0),
    0
  )
  return result || 0
})
// 去除数组null ''
const clear = (arr: any[], keys: string[]) => {
  if (!arr) {
    return []
  }
  let result: any = []
  arr.forEach((v: any) => {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      if (v[k] != null && v[k] !== '') {
        result.push(v)
        break
      }
    }
  })
  if (!result.length) {
    result = [{}]
  }
  return result
}
const handleSubmit = async () => {
  loading.value = true
  const p = cloneDeep(form.value)
  const { replenish, erpInfo, demandInfo, saleInfo } = p.business
  // 地址为空清除、判断地址是否重复
  // if (checkAddressData(form.value.visitAddress)) {
  //   message.error('签到地址不可重复！')
  //   loading.value = false
  //   return false
  // }
  const { visitAddress } = p
  p.visitAddress = clear(visitAddress, ['addressName'])
  // 新增、编辑的格式和详情不同、多传attrList
  if (JSON.stringify(p.visitAddress) === '[{}]') {
    p.visitAddress = { attrList: [] }
  } else {
    p.visitAddress = { attrList: p.visitAddress }
  }
  if (p.business) {
    p.business.replenish = clear(replenish, ['replenishId', 'frequency', 'replenishment'])
    p.business.erpInfo = clear(erpInfo, ['erpId', 'erpAccount'])
    p.business.saleInfo = clear(saleInfo, ['salePlatformId', 'percent'])
    if (demandInfo && demandInfo.warehouses) {
      p.business.demandInfo.warehouses = clear(demandInfo.warehouses, ['warehouseId', 'amount'])
    }
    // 清空产业带名称
    if (p.business.industrialBeltFlag !== 1) {
      p.business.industrialBeltName = ''
    }
    if (p.business.businessTypeSelect) {
      p.business.businessType = [p.business.businessTypeSelect]
      p.business.businessTypeSelect = undefined
    }
  }
  try {
    if (route.query.cosId) {
      await potentialEdit(p)
      message.success(t('tips.editSuccess'))
    } else {
      await potentialAdd(p)
      message.success(t('tips.addSuccess'))
    }
    goBack()
  } catch (error) {}
  loading.value = false
}

// 新增列
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_CosRadioGroup = _resolveComponent("CosRadioGroup")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      name: "advanced_search",
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('common.baseTabs')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: ['customerInfo', 'customerName'],
              label: _unref(t)('custom.customerName'),
              rules: {
          message: _unref(t)('common.pleaseInput'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerInfo.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.customerInfo.customerName) = $event)),
                  maxlength: 50,
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.customerNumber'),
              name: ['customerInfo', 'customerNumber'],
              rules: 
          __props.perfect
            ? {
                message: _unref(t)('common.pleaseSelect'),
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(SerialSelect, {
                  value: form.value.customerInfo.customerNumber,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerInfo.customerNumber) = $event)),
                  cosId: _unref(route).query.cosId,
                  view: __props.formItemView,
                  requiredCosId: true,
                  disabled: !__props.formItemView && !permissionBtn.value.includes(__props.permissionPage.editCode) ? true : false
                }, null, 8, ["value", "cosId", "view", "disabled"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.customerStatus'),
              name: ['customerInfo', 'status'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          validator: _unref(selectForNumberValidate),
          required: true
        }
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.value
                      }, [
                        _createElementVNode("p", null, _toDisplayString(item.label) + _toDisplayString(item.descLang ? `：${_unref(t)(item.descLang)}` : ''), 1)
                      ]))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('custom.customerStatus')), 1),
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(CosSelect, {
                  value: form.value.customerInfo.status,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.customerInfo.status) = $event)),
                  allowClear: "",
                  disabled: __props.disabled || __props.type === 'clients',
                  options: status.value,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "options", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (__props.formItemView && __props.type === 'clients')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.level')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.level,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.customerInfo.level) = $event)),
                        view: __props.formItemView
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.clientsAmount')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.customerInfo.turnoverAmount,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.customerInfo.turnoverAmount) = $event)),
                        view: __props.formItemView,
                        cosType: "money",
                        parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
                        formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      }, null, 8, ["value", "view", "parser", "formatter"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.customerGrad')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosSelect, {
                        value: form.value.customerInfo.grade,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.customerInfo.grade) = $event)),
                        options: _unref(dataConfig).customerGradeEnum,
                        view: __props.formItemView
                      }, null, 8, ["value", "options", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.channel'),
              name: ['customerInfo', 'channel'],
              rules: {
          required: true,
          message: _unref(t)('common.pleaseSelect')
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ParamCodeCascader, {
                      value: form.value.customerInfo.channel,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.customerInfo.channel) = $event)),
                      appId: "cos_ofbu",
                      paramCode: "ofbu_source_channel",
                      status: __props.formItemView ? undefined : 0,
                      disabled: __props.disabled,
                      style: {"width":"33%"},
                      view: __props.formItemView,
                      cosDes: form.value.customerInfo.channelExplain
                    }, null, 8, ["value", "status", "disabled", "view", "cosDes"]),
                    _createVNode(_component_CosInput, {
                      value: form.value.customerInfo.channelExplain,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.customerInfo.channelExplain) = $event)),
                      style: {"width":"67%"},
                      view: __props.formItemView
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.customerOffice'),
              name: ['customerInfo', 'customerOffice'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CustomerArea), {
                  value: form.value.customerInfo.customerOffice,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.customerInfo.customerOffice) = $event)),
                  view: __props.formItemView,
                  "change-on-select": ""
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['customerInfo', 'customerWebsite'],
              label: _unref(t)('custom.officialWeb'),
              rules: {
          message: _unref(t)('common.pleaseInput'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerInfo.customerWebsite,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.customerInfo.customerWebsite) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['customerInfo', 'registerEmail'],
              label: _unref(t)('custom.regEmail')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerInfo.registerEmail,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.customerInfo.registerEmail) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.customerAddress'),
              name: ['customerInfo', 'customerAddress']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerInfo.customerAddress,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.customerInfo.customerAddress) = $event)),
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['customerInfo', 'activityQrcodeId'],
              label: _unref(t)('custom.marketActivity'),
              rules: [{ required: marketRequired.value, message: _unref(t)('common.pleaseSelect') }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSelect, {
                  value: form.value.customerInfo.activityQrcodeId,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.customerInfo.activityQrcodeId) = $event)),
                  options: marketOptions.value,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  optionFilterProp: "label",
                  showSearch: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: "customerRegion",
              label: _unref(t)('custom.customerRegion')
            }, {
              default: _withCtx(() => [
                _createVNode(CustomerAreaCascader, {
                  appId: "cos_ofbu",
                  value: form.value.customerInfo.customerRegion,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.customerInfo.customerRegion) = $event)),
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            (!__props.formItemView)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 1,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('custom.estAveRevenue'),
                        name: ['business', 'annualSales'],
                        rules: { message: _unref(t)('common.pleaseInput'),required: true }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: form.value.business.annualSales,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.business.annualSales) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: __props.formItemView,
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "annualSalesUnit",
                        style: {"width":"30%"},
                        name: ['business', 'annualSalesUnit'],
                        class: "hide-label",
                        rules: { message: _unref(t)('common.pleaseSelect'),required: true }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_currency,
                            value: form.value.business.annualSalesUnit,
                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.business.annualSalesUnit) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  label: _unref(t)('custom.estAveRevenue'),
                  name: ['business', 'annualSalesUnit'],
                  rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: form.value.business?.annualSales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.value.ofbu_currency,
                      value: form.value.business.annualSalesUnit,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.business.annualSalesUnit) = $event)),
                      view: __props.formItemView
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.clientType'),
              name: ['customerInfo', 'clientType'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.ofbu_client_type,
                  value: form.value.customerInfo.clientType,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((form.value.customerInfo.clientType) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.salesChannel'),
              name: ['business', 'salesChannel'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.ofbu_sales_channel,
                  value: form.value.business.salesChannel,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.business.salesChannel) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (__props.formItemView)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.remanentFollowDayType')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.remanentFollowDays,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((form.value.customerInfo.remanentFollowDays) = $event)),
                        view: __props.formItemView
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.followerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.sellerName,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((form.value.customerInfo.sellerName) = $event)),
                        view: __props.formItemView
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.createByName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.createByName,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((form.value.customerInfo.createByName) = $event)),
                        view: __props.formItemView
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.cosId')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.cosId,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((form.value.customerInfo.cosId) = $event)),
                        view: __props.formItemView
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (form.value.customerInfo.status > 19)
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 0,
                        label: _unref(t)('custom.turnedContractTime')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: form.value.customerInfo.turnedContract,
                            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((form.value.customerInfo.turnedContract) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["value", "view"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (form.value.customerInfo.status > 29)
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 1,
                        label: _unref(t)('custom.turnedPotentialTime')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: form.value.customerInfo.turnedTransaction,
                            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((form.value.customerInfo.turnedTransaction) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["value", "view"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (__props.formItemView)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.createTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.createTime,
                        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((form.value.customerInfo.createTime) = $event)),
                        view: __props.formItemView
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.lastReceiveTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.lastReceiveTime,
                        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((form.value.customerInfo.lastReceiveTime) = $event)),
                        view: __props.formItemView
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.turnedPotentialTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.turnedPotential,
                        "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((form.value.customerInfo.turnedPotential) = $event)),
                        view: __props.formItemView
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('custom.concatTitle')
        }, {
          default: _withCtx(() => [
            (__props.formItemView)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: _unref(t)('common.contactName'),
                  name: ['contact', 'lastName'],
                  rules: [
          {
            message: _unref(t)('common.pleaseInput'),
            required: true
          },
          {
            validator: _unref(concatNameValidate)
          }
        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.contact.name,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((form.value.contact.name) = $event)),
                      view: __props.formItemView
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : (_openBlock(), _createBlock(_component_a_col, {
                  key: 1,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_a_form_item, {
                        span: 24,
                        label: _unref(t)('common.firstName'),
                        style: {"width":"50%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: form.value.contact.firstName,
                            "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((form.value.contact.firstName) = $event)),
                            maxlength: 50
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_a_form_item, {
                        label: _unref(t)('common.lastName'),
                        name: ['contact', 'lastName'],
                        style: {"width":"50%"},
                        class: "last-compact",
                        rules: [
              {
                message: _unref(t)('common.pleaseInput'),
                required: true
              },
              {
                validator: _unref(concatNameValidate)
              }
            ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: form.value.contact.lastName,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((form.value.contact.lastName) = $event)),
                            maxlength: 50
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"])
                    ])
                  ]),
                  _: 1
                })),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.mobile'),
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.ofbu_area_code,
                      value: form.value.contact.mobileRegion,
                      "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((form.value.contact.mobileRegion) = $event)),
                      view: __props.formItemView,
                      cosDes: form.value.contact.mobile,
                      style: {"width":"33%"}
                    }, null, 8, ["options", "value", "view", "cosDes"]),
                    _createVNode(_component_dc_form_item, {
                      span: 24,
                      style: {"width":"67%"},
                      class: "last-compact",
                      name: ['contact', 'mobile'],
                      rules: {
              validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, form.value.contact, formRef.value)
            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: form.value.contact.mobile,
                          "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((form.value.contact.mobile) = $event)),
                          view: __props.formItemView
                        }, null, 8, ["value", "view"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'skype'],
              label: _unref(t)('common.skype'),
              rules: {
          validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, form.value.contact, formRef.value)
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.skype,
                  "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((form.value.contact.skype) = $event)),
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'email'],
              label: _unref(t)('common.email'),
              rules: [
          {
            validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, form.value.contact, formRef.value)
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.email,
                  "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((form.value.contact.email) = $event)),
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.jobRole')
            }, {
              default: _withCtx(() => [
                _createVNode(CosSelect, {
                  value: form.value.contact.jobRole,
                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((form.value.contact.jobRole) = $event)),
                  options: _unref(dataConfig).linkRoleTypeEnum,
                  "allow-clear": "",
                  view: __props.formItemView
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.jobDuty')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.jobDuty,
                  "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((form.value.contact.jobDuty) = $event)),
                  view: __props.formItemView,
                  maxlength: 50
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.sex')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.contact.sex,
                  "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((form.value.contact.sex) = $event)),
                  view: __props.formItemView,
                  options: _unref(dataConfig).genderEnum
                }, null, 8, ["value", "view", "options"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.contactRemark'),
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.contact.remark,
                  "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((form.value.contact.remark) = $event)),
                  maxlength: 2000,
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_col, { span: 6 })
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('custom.业务需求')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.业务类型'),
              name: ['business', 'businessTypeSelect'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.businessTypeSelect,
                  "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((form.value.business.businessTypeSelect) = $event)),
                  options: paramCodeData.value.ofbu_business_type,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.服务标准'),
              name: ['business',  'servicesStandard'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.servicesStandard,
                  "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((form.value.business.servicesStandard) = $event)),
                  options: paramCodeData.value.ofbu_services_standard,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.销售平台'),
              name: ['business', 'salePlatform'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.salePlatform,
                  "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((form.value.business.salePlatform) = $event)),
                  options: paramCodeData.value.ofbu_sale_platform,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: "",
                  mode: "multiple"
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.发货量(月)'),
              name: ['business',  'shipments'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.shipments,
                  "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((form.value.business.shipments) = $event)),
                  options: paramCodeData.value.ofbu_shipments,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.产品分类'),
              name: ['business', 'salesCategory'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.ofbu_sales_category,
                  value: form.value.business.salesCategory,
                  "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((form.value.business.salesCategory) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.产品尺寸'),
              name: ['business', 'cargoType'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.ofbu_product_type,
                  value: form.value.business.cargoType,
                  "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((form.value.business.cargoType) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'orderTypeDistribution'],
              label: _unref(t)('custom.订单类型分布'),
              rules: {
          message: _unref(t)('common.pleaseInput'),
          required: true
        }
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('common.订单类型分布输入提示')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('custom.订单类型分布')), 1),
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.orderTypeDistribution,
                  "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((form.value.business.orderTypeDistribution) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  placeholder: _unref(t)('common.订单类型分布输入提示'),
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "placeholder", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'productValue'],
              label: _unref(t)('custom.热销品价值(USD)')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.productValue,
                  "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((form.value.business.productValue) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'orderDistribution'],
              label: _unref(t)('custom.单品多品订单比例'),
              rules: {
          message: _unref(t)('common.pleaseInput'),
          required: true
        }
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('common.单品多品订单比例输入提示')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('custom.单品多品订单比例')), 1),
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.orderDistribution,
                  "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((form.value.business.orderDistribution) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  placeholder: _unref(t)('common.单品多品订单比例输入提示')
                }, null, 8, ["value", "disabled", "view", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'skuType'],
              label: _unref(t)('custom.SKU种类'),
              rules: {
          message: _unref(t)('common.pleaseInput'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.skuType,
                  "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((form.value.business.skuType) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.SKU单位'),
              name: ['business', 'skuUnit'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.skuUnit,
                  "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((form.value.business.skuUnit) = $event)),
                  options: paramCodeData.value.ofbu_sku_unit,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: "",
                  mode: "multiple"
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.尾程服务需求'),
              name: ['business', 'serviceType'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.serviceType,
                  "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((form.value.business.serviceType) = $event)),
                  options: paramCodeData.value.ofbu_service_type,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: "",
                  mode: "multiple"
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.区域仓'),
              name: ['business', 'regionalWarehouse'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.regionalWarehouse,
                  "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((form.value.business.regionalWarehouse) = $event)),
                  options: paramCodeData.value.ofbu_demand_info,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: "",
                  mode: "multiple"
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.入库包装方式'),
              name: ['business', 'inboundPackageType'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.inboundPackageType,
                  "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((form.value.business.inboundPackageType) = $event)),
                  options: paramCodeData.value.ofbu_inbound_package_type,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: "",
                  mode: "multiple"
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'averageInventoryVolume'],
              label: _unref(t)('custom.平均在库体积'),
              rules: {
          message: _unref(t)('common.pleaseInput'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.averageInventoryVolume,
                  "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((form.value.business.averageInventoryVolume) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'firstInboundTime'],
              label: _unref(t)('custom.预计第一次来货时间'),
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  isOutputBeijingTime: "",
                  startTime: form.value.business.firstInboundTime,
                  "onUpdate:startTime": _cache[54] || (_cache[54] = ($event: any) => ((form.value.business.firstInboundTime) = $event)),
                  isRange: false,
                  view: __props.formItemView
                }, null, 8, ["startTime", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'futureIncrement'],
              label: _unref(t)('custom.未来增量(月订单)')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.futureIncrement,
                  "onUpdate:value": _cache[55] || (_cache[55] = ($event: any) => ((form.value.business.futureIncrement) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'systemIntegration'],
              label: _unref(t)('custom.系统对接需求')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.systemIntegration,
                  "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => ((form.value.business.systemIntegration) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  placeholder: _unref(t)('common.系统对接需求输入提示')
                }, null, 8, ["value", "disabled", "view", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.其他附件'),
              name: "otherFile",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  view: __props.formItemView,
                  value: form.value.business.otherFile,
                  "onUpdate:value": _cache[57] || (_cache[57] = ($event: any) => ((form.value.business.otherFile) = $event)),
                  valueType: "array"
                }, null, 8, ["view", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('custom.报价'),
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.价格类型'),
              name: ['business', 'quotationInfo', 'quotationType'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: props.type !== 'potential'
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.quotationInfo.quotationType,
                  "onUpdate:value": _cache[59] || (_cache[59] = ($event: any) => ((form.value.business.quotationInfo.quotationType) = $event)),
                  options: paramCodeData.value.ofbu_quotation_type,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: ['business', 'quotationInfo', 'fulfillmentRatesVersion'],
                  label: _unref(t)('custom.仓储报价版本'),
                  rules: {
              message: _unref(t)('common.pleaseInput'),
              required: props.type !== 'potential' && quotationAndBusinessChange.value
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.business.quotationInfo.fulfillmentRatesVersion,
                      "onUpdate:value": _cache[60] || (_cache[60] = ($event: any) => ((form.value.business.quotationInfo.fulfillmentRatesVersion) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: __props.disabled,
                      view: __props.formItemView
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  name: ['business', 'quotationInfo', 'shippingRatesVersion'],
                  label: _unref(t)('custom.尾程报价版本'),
                  rules: {
              message: _unref(t)('common.pleaseInput'),
              required: props.type !== 'potential' && quotationAndBusinessChange.value
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.business.quotationInfo.shippingRatesVersion,
                      "onUpdate:value": _cache[61] || (_cache[61] = ($event: any) => ((form.value.business.quotationInfo.shippingRatesVersion) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: __props.disabled,
                      view: __props.formItemView
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (form.value.business.quotationInfo.quotationType === 3469)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  name: ['business', 'quotationInfo', 'priceDocuments'],
                  label: _unref(t)('custom.报价策略'),
                  rules: { required: form.value.business.quotationInfo.quotationType === 3469, message: _unref(t)('common.pleaseInput') }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.business.quotationInfo.priceDocuments,
                      "onUpdate:value": _cache[62] || (_cache[62] = ($event: any) => ((form.value.business.quotationInfo.priceDocuments) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: __props.disabled,
                      view: __props.formItemView
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(MultipleItem, {
                  key: 3,
                  view: __props.formItemView
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.quotationInfo.details, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_3, _toDisplayString(`${_unref(t)('custom.区域仓')}${index+1}`), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_dc_form_item, {
                          label: _unref(t)('custom.区域仓'),
                          span: 3,
                          name: ['business', 'quotationInfo', 'details', index, 'regionalWarehouse']
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: item.regionalWarehouse,
                              "onUpdate:value": ($event: any) => ((item.regionalWarehouse) = $event),
                              options: paramCodeData.value.ofbu_demand_info,
                              disabled: __props.disabled,
                              view: __props.formItemView,
                              allowClear: ""
                            }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["label", "name"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'subWarehouseCode'],
                          label: _unref(t)('custom.物理仓'),
                          span: 3
                        }, {
                          label: _withCtx(() => [
                            _createVNode(_component_a_tooltip, {
                              placement: "topLeft",
                              overlayStyle: { maxWidth: '800px' }
                            }, {
                              title: _withCtx(() => [
                                _hoisted_4
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('custom.物理仓')), 1),
                                _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.subWarehouseCode,
                              "onUpdate:value": ($event: any) => ((item.subWarehouseCode) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              ignorePlaceHolder: "",
                              disabled: "",
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'storageFeeDiscount'],
                          label: _unref(t)('custom.仓租折扣(%)'),
                          span: 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.storageFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.storageFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: __props.disabled,
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'handingFeeDiscount'],
                          label: _unref(t)('custom.操作费折扣(%)'),
                          span: 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.handingFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.handingFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: __props.disabled,
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'shippingFeeDiscount'],
                          label: _unref(t)('custom.尾程折扣(%)'),
                          span: 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.shippingFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.shippingFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: __props.disabled,
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'remark'],
                          label: _unref(t)('common.remark'),
                          span: 6
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.remark,
                              "onUpdate:value": ($event: any) => ((item.remark) = $event),
                              maxlength: 2000,
                              disabled: __props.disabled,
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        (
                 !__props.formItemView &&
                  form.value.business.quotationInfo.details &&
                  form.value.business.quotationInfo.details.length > 1
                )
                          ? (_openBlock(), _createBlock(_component_dc_form_item, {
                              key: 0,
                              span: 3
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "text",
                                  danger: "",
                                  style: {"padding":"0 0 0 12px"},
                                  onClick: ($event: any) => (handleDelCol(form.value.business.quotationInfo.details,index))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["view"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.客户报价/竞对报价'),
              name: ['business', 'quotationInfo', 'competitorPriceDocuments'],
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  view: __props.formItemView,
                  value: form.value.business.quotationInfo.competitorPriceDocuments,
                  "onUpdate:value": _cache[63] || (_cache[63] = ($event: any) => ((form.value.business.quotationInfo.competitorPriceDocuments) = $event)),
                  valueType: "array"
                }, null, 8, ["view", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 2
        }, [
          (!__props.formItemView&&quotationAndBusinessChange.value)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[58] || (_cache[58] = ($event: any) => (handleAddCol(form.value.business.quotationInfo.details)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('custom.合同和账期'),
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.服务公司'),
              name: ['business', 'contractInfo', 'serviceCompany'],
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: props.type !== 'potential'
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.contractInfo.serviceCompany,
                  "onUpdate:value": _cache[64] || (_cache[64] = ($event: any) => ((form.value.business.contractInfo.serviceCompany) = $event)),
                  options: paramCodeData.value.ofbu_service_body,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.付款方式'),
              name: ['business', 'contractInfo', 'paymentType'],
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: props.type !== 'potential'
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.contractInfo.paymentType,
                  "onUpdate:value": _cache[65] || (_cache[65] = ($event: any) => ((form.value.business.contractInfo.paymentType) = $event)),
                  options: paramCodeData.value.ofbu_payment_type,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.出账周期(天)'),
              name: ['business', 'contractInfo', 'billingTerm'],
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: props.type !== 'potential'
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.contractInfo.billingTerm,
                  "onUpdate:value": _cache[66] || (_cache[66] = ($event: any) => ((form.value.business.contractInfo.billingTerm) = $event)),
                  options: paramCodeData.value.ofbu_billing_term,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (form.value.business.contractInfo.paymentType === 3504
         || form.value.business.contractInfo.paymentType === 3473)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: ['business', 'contractInfo', 'paymentTerm'],
                  label: _unref(t)('custom.付款周期(天)'),
                  rules: {
              message: _unref(t)('common.pleaseInput'),
              required: form.value.business.contractInfo.paymentType === 3473
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.business.contractInfo.paymentTerm,
                      "onUpdate:value": _cache[67] || (_cache[67] = ($event: any) => ((form.value.business.contractInfo.paymentTerm) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: __props.disabled,
                      view: __props.formItemView
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (!__props.formItemView && form.value.business.contractInfo.paymentType === 3504)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 1,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('custom.固定额度'),
                        name: ['business', 'contractInfo', 'fixedCredit', 'amount'],
                        rules: {
              message: _unref(t)('common.pleaseInput'),
              required: true
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: form.value.business.contractInfo.fixedCredit.amount,
                            "onUpdate:value": _cache[68] || (_cache[68] = ($event: any) => ((form.value.business.contractInfo.fixedCredit.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: __props.formItemView,
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "fixedCreditCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'fixedCredit', 'currency'],
                        class: "hide-label",
                        rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_currency,
                            value: form.value.business.contractInfo.fixedCredit.currency,
                            "onUpdate:value": _cache[69] || (_cache[69] = ($event: any) => ((form.value.business.contractInfo.fixedCredit.currency) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.formItemView && form.value.business.contractInfo.paymentType === 3504)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  label: _unref(t)('custom.固定额度'),
                  name: ['business', 'contractInfo', 'fixedCredit', 'currency'],
                  rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: form.value.business.contractInfo.fixedCredit.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.value.ofbu_currency,
                      value: form.value.business.contractInfo.fixedCredit.currency,
                      "onUpdate:value": _cache[70] || (_cache[70] = ($event: any) => ((form.value.business.contractInfo.fixedCredit.currency) = $event)),
                      view: __props.formItemView
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (!__props.formItemView)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 3,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('custom.系统注册费'),
                        name: ['business', 'contractInfo', 'registrationFee', 'amount'],
                        rules: {
              message: _unref(t)('common.pleaseInput'),
              required: props.type !== 'potential'
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: form.value.business.contractInfo.registrationFee.amount,
                            "onUpdate:value": _cache[71] || (_cache[71] = ($event: any) => ((form.value.business.contractInfo.registrationFee.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: __props.formItemView,
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "registrationFeeCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'registrationFee', 'currency' ],
                        class: "hide-label",
                        rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: props.type !== 'potential'
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_currency,
                            value: form.value.business.contractInfo.registrationFee.currency,
                            "onUpdate:value": _cache[72] || (_cache[72] = ($event: any) => ((form.value.business.contractInfo.registrationFee.currency) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 4,
                  label: _unref(t)('custom.系统注册费'),
                  name: ['business', 'contractInfo', 'registrationFee', 'currency'],
                  rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: props.type !== 'potential'
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: form.value.business.contractInfo.registrationFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.value.ofbu_currency,
                      value: form.value.business.contractInfo.registrationFee.currency,
                      "onUpdate:value": _cache[73] || (_cache[73] = ($event: any) => ((form.value.business.contractInfo.registrationFee.currency) = $event)),
                      view: __props.formItemView
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])),
            (!__props.formItemView)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 5,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('custom.系统管理月费'),
                        name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'amount'],
                        rules: {
              message: _unref(t)('common.pleaseInput'),
              required: props.type !== 'potential'
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: form.value.business.contractInfo.monthlyMaintenanceFee.amount,
                            "onUpdate:value": _cache[74] || (_cache[74] = ($event: any) => ((form.value.business.contractInfo.monthlyMaintenanceFee.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: __props.formItemView,
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "monthlyMaintenanceFeeCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency'],
                        class: "hide-label",
                        rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: props.type !== 'potential'
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_currency,
                            value: form.value.business.contractInfo.monthlyMaintenanceFee.currency,
                            "onUpdate:value": _cache[75] || (_cache[75] = ($event: any) => ((form.value.business.contractInfo.monthlyMaintenanceFee.currency) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 6,
                  label: _unref(t)('clue.系统管理月费'),
                  name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency'],
                  rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: props.type !== 'potential'
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: form.value.business.contractInfo.monthlyMaintenanceFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.value.ofbu_currency,
                      value: form.value.business.contractInfo.monthlyMaintenanceFee.currency,
                      "onUpdate:value": _cache[76] || (_cache[76] = ($event: any) => ((form.value.business.contractInfo.monthlyMaintenanceFee.currency) = $event)),
                      view: __props.formItemView
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.客户特殊服务'),
              name: ['business', 'contractInfo', 'additionalServices'],
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: props.type !== 'potential'
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.contractInfo.additionalServices,
                  "onUpdate:value": _cache[77] || (_cache[77] = ($event: any) => ((form.value.business.contractInfo.additionalServices) = $event)),
                  options: paramCodeData.value.ofbu_service_demand,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: "",
                  mode: "multiple"
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'contractInfo', 'legalSystemApplicationNo'],
              label: _unref(t)('custom.法务流程编码'),
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: props.type !== 'potential'
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.contractInfo.legalSystemApplicationNo,
                  "onUpdate:value": _cache[78] || (_cache[78] = ($event: any) => ((form.value.business.contractInfo.legalSystemApplicationNo) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.remark'),
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.customerInfo.remark,
                  "onUpdate:value": _cache[79] || (_cache[79] = ($event: any) => ((form.value.customerInfo.remark) = $event)),
                  maxlength: 2000,
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["model"]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          value: form.value,
          "onUpdate:value": _cache[80] || (_cache[80] = ($event: any) => ((form).value = $event)),
          resetValue: resetValue.value,
          formRef: formRef.value,
          loading: loading.value,
          onSubmit: handleSubmit,
          disabled: __props.disabled,
          permissionPage: __props.permissionPage
        }, null, 8, ["value", "resetValue", "formRef", "loading", "disabled", "permissionPage"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})